// In production, it's not null and right now this is a temporary workaround until we merged Core into jsm.
// However, tests will fail due to Core being undefined otherwise.
export const travianFeatures = typeof Core === 'undefined' ? null : Core.tfeatures;
export const travianCurrentServer = typeof Core === 'undefined' ? null : Core.currentServer;
